import { ValidationRules } from 'aurelia-validation';
import { WidgetController } from 'controls/as-widget-container';
import { NoteSegment } from 'model/forms/trip-details';
import { WidgetBase } from 'support/base_classes/widget-base';

export class NoteSegmentWidget extends WidgetBase<NoteSegment, WidgetController> {
  bind() {
    ValidationRules
      .ensureObject<NoteSegment>().required()
      .ensure(model => model.note).displayName('Note content').required()
      .on(this.model);
  }
}
